import { tv } from '@change/ds-utils';

export const PostPreviewStyles = tv({
	base: 'stroke-weaker bg-background-base flex flex-col overflow-hidden border',
	variants: {
		size: {
			small: 'h-[218px] w-[100px] rounded-[10px] border-[1.5px]',
			medium: 'h-[436px] w-[200px] rounded-[20px] border-[3px]',
			large: 'h-[507px] w-[233px] rounded-3xl border-4',
		},
	},
});
